import { render } from "./PortfolioLogo.vue?vue&type=template&id=7eaa87a9"
import script from "./PortfolioLogo.vue?vue&type=script&lang=js"
export * from "./PortfolioLogo.vue?vue&type=script&lang=js"

import "./PortfolioLogo.vue?vue&type=style&index=0&id=7eaa87a9&lang=scss"

import exportComponent from "C:\\Users\\Kyler\\OneDrive\\Website\\website2022\\development\\kylerherrera-2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__